module.exports = __webpack_public_path__ + "assets/img/jiaren.15e058f6.png";